import { render, staticRenderFns } from "./Carousel_release.vue?vue&type=template&id=f829b8b0&style=true"
import script from "./Carousel_release.vue?vue&type=script&lang=js"
export * from "./Carousel_release.vue?vue&type=script&lang=js"
import style0 from "./Carousel_release.vue?vue&type=style&index=0&id=f829b8b0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports